import React from "react"
// import './SearchEngineOptimization.css'
import monitoringTheDeviation from '../../assets/images/monitoringTheDeviation.webp'
import googleadsLogo from '../../assets/logos/googleadsLogo.jpg'
import metaadsLogo from '../../assets/logos/metaadsLogo.jpg'
import microsoftadsLogo from '../../assets/logos/microsoftadsLogo.jpg'
import linkedinLogo from '../../assets/logos/linkedinLogo.jpg'
import { Link } from "react-router-dom"


import searchEngineOptimizationBanner from '../../assets/bannerImages/searchEngineOptimization.jpg'

import winWithSeo from '../../assets/images/winWithSeo.jpg'
import fullSeoCoverage from '../../assets/images/fullSeoCoverage.jpg'


import comprehensiveKeywordResearch from '../../assets/images/comprehensiveKeywordResearch.jpg'
import productionExcellence from '../../assets/images/productionExcellence.jpg'
import amplifiedOffPageStrategies from '../../assets/images/amplifiedOffPageStrategies.jpg'

export default function SearchEngineOptimization(){
    return(
        <div className="searchEngineOptimization">
            <SEOR1/>
            <SEOR2/>
            <SEOR3/>
            <SEOR4/>
            <ContactSection/>
            {/* this contact section's css is in social media marketing page's css file */}
        </div>
    )
}

function SEOR1(){
    return(
        <div className='seor1'>
            <img loading="lazy" src={searchEngineOptimizationBanner} alt='seo-banner' className='seo-banner-img'/>
            <h1 className='seor1-head'>Search Engine Optimization</h1>
            <div className='overlay'></div>
        </div>
    )
}

function SEOR2(){
    return(
        <div className='seor2'>
            <div className='strip'>
                <h1>What is <span>Search Engine Optimization</span>?</h1>
                <hr/>   
                <p>Search Engine Optimization (SEO) involves improving a website's visibility on search engine results pages (SERPs) by optimizing elements like keywords and content quality. It aims to enhance organic traffic and attract relevant visitors, utilizing both on-page and off-page optimization techniques for increased online visibility and brand authority.</p>
            </div>
        </div>
    )
}

function SEOR3(){
    return(
        <div className='seor3'>
            <div className='rowThreeContainer'>
                <h1 className='rowThreeHead'>
                Why <span>Choose Bixian</span> for Search Engine Optimization?
                </h1>
                <p className='rowThreeContext'>
                When it comes to Search Engine Optimization (SEO), Bixian is your trusted partner for driving organic traffic and enhancing online visibility. Here's why you should choose us:
                </p>
                <div className='rowThreeBoxes'>
                    {/* box 1 */}
                    <div className='box boxOne'>
                        <div className='context'>
                            <img loading="lazy" src={winWithSeo} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Win with SEO
                            </h2>
                            <p className='boxPara'>
                            Bixian's SEO experts deliver results. We craft custom plans to boost your online presence and achieve business goals.
                            </p>
                        </div>
                    </div>
                    {/* box 2 */}
                    <div className='box boxTwo'>
                        <div className='context'>
                            <img loading="lazy" src={fullSeoCoverage} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Full SEO Coverage
                            </h2>
                            <p className='boxPara'>
                            We cover all SEO areas: on-page, off-page, technical, and content. This drives rankings and growth.
                            </p>
                        </div>
                    </div>
                    {/* box 3 */}
                    <div className='box boxThree'>
                        <div className='context'>
                            <img loading="lazy" src={monitoringTheDeviation} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Data-Driven SEO
                            </h2>
                            <p className='boxPara'>
                            We use data to find opportunities, track results, and constantly improve your SEO for success.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

function SEOR4(){
    return(
        <div className='seor4'>
            <div className='rowFourContainer'>
                <div className='rowFourContext'>
                    <h1 className='rowFourHead'>Our Process</h1>
                    <p className='rowFourPara'>
                    Unlock the potential of Video Advertising with Bixian's streamlined process. We understand the importance of captiseoting visuals and compelling storytelling to engage your audience effectively.
                    </p>
                </div>
                <div className='rowFourBoxes'>
                    <div className='box boxOne'>
                            <img loading="lazy" src={comprehensiveKeywordResearch} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Comprehensive Keyword Research</h2>
                        <p className='boxPara'>Our SEO experts meticulously research to uncover high-impact keywords aligning with your business goals and target audience.</p>
                    </div>
                    <div className='box boxTwo'>
                            <img loading="lazy" src={productionExcellence} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Production Excellence</h2>
                        <p className='boxPara'>We meticulously optimize your website's on-page elements (title tags, headings, content) for search engines and user experience.</p>
                    </div>
                    <div className='box boxThree'>
                            <img loading="lazy" src={amplifiedOffPageStrategies} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Amplified Off-Page Strategies</h2>
                        <p className='boxPara'>We leverage strategic link building, content marketing, and social media to build online authority, driving organic traffic and ranking improvement.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our Search Engine Optimization?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}